import createRoute  from '@widesk-ui/tools/createRoute';
import AccountModel from '@models/account/AccountModel';

export default createRoute.dashboard('/accounts', 'account', 'AccountDashboard', AccountModel.localize());